import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const FormsTranslations = wrapTranslationsSchema({
	name: 'FormsTranslations',
	title: 'Forms Translations',
	sanityId: 'forms',
	fields: {
		errorMessage: 'Error loading form',
		validationRequired: 'Field is required',
		validationMaxLength: 'Value should be less than {length} character',
		submit: 'Submit',
		nextForm: 'Next',
		prevForm: 'Back',
		saveAllForms: 'Save for later',
		saveForm: 'Save form',
		cancel: 'Cancel',
		submitWarningMessage: 'Fill out the mandatory fields to be able to submit your request.',
		draftFormMessage: 'We saved your progress. It will be deleted after the current tab is closed',
	},
});
